import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=c74a47ec&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c74a47ec')) {
      api.createRecord('c74a47ec', component.options)
    } else {
      api.reload('c74a47ec', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=c74a47ec&", function () {
      api.rerender('c74a47ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CZlkkF6eo63Y/JS/comp/childrenage.vue"
export default component.exports